<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

    page: {
        title: 'Новый телефонный номер',
        meta: [{ name: 'description', content: appConfig.description }],
    },

    components: { Layout, PageHeader, Multiselect },

    data() {
        return {
            title: 'Новый телефонный номер',
            items: [],
            trunk_phone_uuid: '',
            number: '',
            config: '',
            trackBy: 'id',
            
            initStatus: [],
            status: null,
            status_options: [
                {id: 'created', name: 'Новый'},
                {id: 'connect', name: 'Подключение'},
                {id: 'active', name: 'Активен'},
                {id: 'blocked', name: 'Заблокирован'},
                {id: 'disabled', name: 'Отключен'}
            ],
            
            trunk: null,
            initTrunk: [],
            trunks_options: [],

            account: null,
            initAccount: [],
            account_options: [],

            initBot: [],
            bot: null,
            bots_options: [],

            allow_incoming_calls: false
        }
    },

    watch: {
        initStatus: {
            immediate: true,
            handler(values) {
                this.status = this.status_options.filter(x => values.includes(x[this.trackBy]));
                this.status = this.status[0];
            }
        },
        initTrunk: {
            immediate: true,
            handler(values) {
                this.trunk = this.trunks_options.filter(x => values.includes(x[this.trackBy]));
                this.trunk = this.trunk[0];
            }
        },
        initAccount: {
            immediate: true,
            async handler(values) {
                this.account = this.account_options.filter(x => values.includes(x[this.trackBy]));
                this.account = this.account[0];
            }
        },
        account: {
            immediate: true,
            async handler(value) {
                if(value){
                    if(value && value.user_id){
                        await this.$store.dispatch('bots/FETCH_BOTS_LIST', {'filter': value.user_id, 'filterOn': JSON.stringify(['user_id'])});
                        this.bots_options = this.bots_list_data;
                        this.initBot = [this.bot];
                    }
                    if(value && value.id){
                        await this.$store.dispatch('trunks/FETCH_TRUNKS_LIST', {'filter': value.id, 'filterOn': JSON.stringify(['account_id'])});
                        this.trunks_options = this.trunks_list_data;
                        this.initTrunk = [this.trunk];
                    }
                }
            }
        },
        initBot: {
            immediate: true,
            handler(values) {
                this.bot = this.bots_options.filter(x => values.includes(x[this.trackBy]));
                this.bot = this.bot[0];
            }
        },        
    },

    computed: {
        trunk_phone_item(){
            return this.$store.getters['trunksPhones/GET_TRUNKS_PHONES_ITEM'];
        },
        bots_list_data(){
            return this.$store.getters['bots/GET_BOTS_LIST_DATA'];
        },
        trunks_list_data(){
            return this.$store.getters['trunks/GET_TRUNKS_LIST_DATA'];
        },
        accounts_list_data(){
            return this.$store.getters['accounts/GET_ACCOUNTS_LIST_DATA'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
    },

    async mounted() {

        this.trunk_phone_uuid = this.$route.params.trunk_phone_uuid ? this.$route.params.trunk_phone_uuid : '';

        if(this.trunk_phone_uuid !== ''){

            this.title = 'Редактирование телефонного номера';
            document.title = appConfig.title + ' - ' + 'Редактирование телефонного номера';

            let data_send = {
                'uuid' : this.trunk_phone_uuid,
            }

            await this.$store.dispatch('trunksPhones/FETCH_TRUNKS_PHONES_ITEM', data_send);
            this.number  = this.trunk_phone_item.number ? this.trunk_phone_item.number : '';
            this.config  = this.trunk_phone_item.config ? JSON.parse(this.trunk_phone_item.config) : this.config;
            let account = this.trunk_phone_item.account_id ? this.trunk_phone_item.account_id : null;

            await this.$store.dispatch('accounts/FETCH_ACCOUNTS_LIST', {'filter': account, 'filterOn': JSON.stringify(['id'])});
            this.account_options = this.accounts_list_data;

            this.status  = this.trunk_phone_item.status ? this.trunk_phone_item.status : '';
            this.bot = this.trunk_phone_item.bot_id ? this.trunk_phone_item.bot_id : '';
            this.allow_incoming_calls = this.trunk_phone_item.bot_id && this.trunk_phone_item.bot_id !== null ? true : false;
            this.trunk = this.trunk_phone_item.trunk_id ? this.trunk_phone_item.trunk_id : null;

            this.initStatus  = [this.status];
            this.initAccount = [account];

        } else {
            await this.$store.dispatch('accounts/FETCH_ACCOUNTS_LIST', {'limit': 2000});
            this.account_options = this.accounts_list_data;
        }
    },

    methods: {
        async saveItem(){

            let data_send = {
                'number'     : this.number,
                'account_id' : this.account && this.account.id ? this.account.id : null,
                'user_id'    : this.account && this.account.user_id ? this.account.user_id : null,
                'bot_id'     : this.bot && this.bot.id ? this.bot.id : null,
                'config'     : JSON.stringify(this.config),
                'status'     : this.status && this.status.id ? this.status.id : null,
                'trunk_id'   : this.trunk && this.trunk.id ? this.trunk.id : null,
            };

            let result = '';

            if(this.trunk_phone_uuid === ''){
                result = await this.$store.dispatch('trunksPhones/FETCH_TRUNKS_PHONES_CREATE', data_send);
            } else {
                data_send.uuid = this.trunk_phone_uuid;
                result = await this.$store.dispatch('trunksPhones/FETCH_TRUNKS_PHONES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Trunks.Phones'});
            }
        }
    },
}

</script>

<template>
    <Layout>
        <PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">

                                    <b-form-group
                                        label="Аккаунт клиента"
                                        label-for="account"
                                    >
                                        <multiselect
                                            id="account"
                                            :track-by="trackBy"
                                            v-model="account"
                                            :options="account_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Номер"
                                        label-for="number"
                                    >
                                        <b-form-input
                                            id="number"
                                            v-model="number"
                                            placeholder="Укажите телефонный номер"
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Транк"
                                        label-for="trunk"
                                    >
                                        <multiselect
                                            id="trunk"
                                            :track-by="trackBy"
                                            v-model="trunk"
                                            :options="trunks_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-checkbox v-model="allow_incoming_calls" @change="bot = null" name="config_record" style="margin-top: 5px; margin-bottom: 15px" switch>
                                        Разрешить входящие звонки 
                                    </b-form-checkbox>
                                    
                                    <b-form-group
                                        v-if="allow_incoming_calls"
                                        label="Ответственный"
                                        label-for="bot"
                                    >
                                        <multiselect
                                            id="bot"
                                            :track-by="trackBy"
                                            v-model="bot"
                                            :options="bots_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>

                                    <b-form-group
                                        label="Статус"
                                        label-for="status"
                                    >
                                        <multiselect
                                            id="status"
                                            :track-by="trackBy"
                                            v-model="status"
                                            :options="status_options"
                                            placeholder="Выберите из списка"
                                            selectLabel="Нажмите, чтобы выбрать"
                                            deselectLabel="Нажмите, снять выделение"
                                            label="name"
                                        ></multiselect>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
    </Layout>
</template>
